
import * as CSS from 'csstype';
import styled, { css } from 'styled-components';
import { boxShadow } from '@/common/styled-mixins';
import { PanelContent } from './panel-content';
import { PanelFooter } from './panel-footer';
import { PanelHeader } from './panel-header';

export interface IPanelProps {
    background?: CSS.BackgroundProperty<string>;
    width?: CSS.WidthProperty<number>;
    height?: CSS.HeightProperty<number>;
    margin?: CSS.MarginBlockProperty<number>;
    direction?: CSS.FlexDirectionProperty;
}

export const Panel = styled.div<IPanelProps>`
    ${boxShadow}
    box-sizing: border-box;
    width: ${props => props.width || '100%'};
    height: ${props => props.height || 'auto'};
    border-radius: 4px;
    display: flex;
    flex-direction: ${props => props.direction || 'column'};
    background: ${props => props.background || '#fff'}

    ${props => props.margin
    && css`
        margin: ${props.margin};
    `}

    ${PanelFooter}, ${PanelHeader}, ${PanelContent} {
        box-sizing: border-box;
    }

    ${PanelContent} {
        flex-grow: 1;
    }

    ${PanelFooter}, ${PanelHeader} {
        flex-grow: 0;
        display: flex;
        align-items: center;
    }
`;
